import SEO_BY_LANG from '@/lang/seo'

/**
 * 按当前语种刷新页面 <title> / description / html.lang / html.dir。
 * 路由变化和手动切换语种都要调它 —— 否则切语言后标题还停在上一门语言。
 * @param {string} path   当前路由 path
 * @param {string} locale 语种 sign（zh-CN/en/ja/...）
 */
export function updatePageSEO (path, locale) {
  const html = document.documentElement
  html.lang = locale === 'zh-CN' ? 'zh-CN' : locale
  html.setAttribute('dir', locale === 'ar' ? 'rtl' : 'ltr')

  // 语种没有就整份回退英文；英文也没有就保持原样
  const dict = SEO_BY_LANG[locale] || SEO_BY_LANG['en'] || {}
  const data = dict[path] || (SEO_BY_LANG['en'] || {})[path]
  if (!data) return

  document.title = data.title
  const metaDesc = document.querySelector("meta[name='description']")
  if (metaDesc) metaDesc.setAttribute('content', data.desc)
}

export default updatePageSEO
